import { environment } from '$environments/environment';
import { HorseDTO } from '$types';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class HorseService {
  private horsesUrl: string = environment.apiUrl + '/rest/horses';
  private postsUrl: string = environment.apiUrl + '/rest/posts';

  constructor(private readonly http: HttpClient) { }

  findBySire(sire: string): Observable<HorseDTO | null> {
    const has_correct_sire = /^\d+[A-Za-z]$/.test(sire);
    if (!has_correct_sire) return of(null);
    return this.http
      .get<HorseDTO[]>(`${this.horsesUrl}?sire=${sire}`)
      .pipe(map((result: HorseDTO[]) => result[0]));
  }

}
